import { Box, Card, Text, Group, LoadingOverlay } from '@mantine/core';
import { IconChartBar } from '@tabler/icons-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { showNotification } from '@mantine/notifications';
import { getQuotaInfo, UserQuota } from '@mygpt/app';
import { QuotaDisplay } from './QuotaDisplay';

export const PackageQuota = () => {
  const { t } = useTranslation();
  const [quotaData, setQuotaData] = useState<UserQuota | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await getQuotaInfo();
        if (res.data) {
          setQuotaData(res.data);
        }
      } catch (error: any) {
        showNotification({
          color: 'red',
          title: t('quota.messages.loadFailed'),
          message: error.message || t('quota.messages.loadFailedDesc'),
        });
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [t]);

  return (
    <Box>
      <Card shadow="sm" padding="xl" radius="md" withBorder pos="relative">
        <LoadingOverlay visible={loading} />

        <Group mb="xl">
          <IconChartBar size={20} color="var(--mantine-color-violet-6)" />
          <Text fw={600} size="lg">
            {t('quota.title')}
          </Text>
        </Group>

        {quotaData?.active_plan_subscription ? (
          <QuotaDisplay
            planSubscription={quotaData.active_plan_subscription}
            isCorporate={quotaData.effective_quotas?.is_corporate}
            addOnSubscriptions={quotaData.active_add_on_subscriptions}
          />
        ) : (
          !loading && (
            <Text c="dimmed" ta="center" py="xl">
              {t('quota.empty')}
            </Text>
          )
        )}
      </Card>
    </Box>
  );
};
